import React from 'react';
import moment from 'moment';
import IconArrowDown from "../IconArrowDown";
import "./style.css";

const SelectField = ({
  className = '',
  name = null,
  disabled = null,
  required = false,
  options = [],
  value = '',
  onClick = null,
  placeholder = null,
  readOnly = false,
  onChange = null,
  label = null,
  icon = null,
  bulk = false,
  availabilityStore = null
}) => {
  const renderOptions = availabilityStore => {
    if (availabilityStore !== undefined) {
      const filteredTzs = availabilityStore.staticData.timezones.sort((a, b) => {
        const nameA = a.name.toLowerCase();
        const nameB = b.name.toLowerCase();
        if (nameA < nameB) return -1;
        if (nameA > nameB) return 1;
        return 0;
      });
      return filteredTzs.map(x => /*#__PURE__*/React.createElement("option", {
        key: x.id,
        value: x.name
      }, x.name, " ", moment().utc().tz(x.name).format('Z')));
    } else {
      return options.map(option => /*#__PURE__*/React.createElement("option", {
        key: option.value,
        value: option.value
      }, option.name));
    }
  };

  return /*#__PURE__*/React.createElement("div", {
    className: `atheneum-input ${className}`,
    onClick: onClick,
    role: "button",
    tabIndex: 0
  }, label && /*#__PURE__*/React.createElement("label", null, label), /*#__PURE__*/React.createElement("div", {
    className: "atheneum-input-wrapper"
  }, /*#__PURE__*/React.createElement("span", {
    className: "atheneum-input-icon"
  }, /*#__PURE__*/React.createElement("i", {
    className: icon
  })), readOnly ? /*#__PURE__*/React.createElement("div", null, options.filter(option => option.value === value)[0] ? options.filter(option => option.value === value)[0]['name'] : '---') : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("select", {
    className: "atheneum-input-select",
    onChange: onChange,
    disabled: disabled,
    required: required,
    value: value,
    name: name
  }, bulk ? null : /*#__PURE__*/React.createElement("option", null, placeholder || label || 'Please Select'), renderOptions(availabilityStore)), /*#__PURE__*/React.createElement(IconArrowDown, {
    className: disabled === true ? 'disabled' : ''
  }))));
};

export default SelectField;